import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { EntradaListarRoutingModule } from "./entrada-listar-routing.module";
import { EntradaListarComponent } from "./entrada-listar.component";

import { ButtonModule } from "primeng/button";
import { ChipModule } from "primeng/chip";
import { EditorModule } from "primeng/editor";
import { FileUploadModule } from "primeng/fileupload";
import { InputTextModule } from "primeng/inputtext";
import { InputTextareaModule } from "primeng/inputtextarea";
import { RippleModule } from "primeng/ripple";
import { TableModule } from 'primeng/table';
import { HttpClientModule } from "@angular/common/http";
import { TooltipModule } from "primeng/tooltip";
import { DividerModule } from "primeng/divider";
import { SplitButtonModule } from 'primeng/splitbutton';
import {ConfirmDialogModule} from 'primeng/confirmdialog';
import { ConfirmationService } from "primeng/api";
import { ProgressSpinnerModule } from "primeng/progressspinner";



@NgModule({
    imports: [
        CommonModule,
        ButtonModule,
        InputTextModule,
        InputTextareaModule,
        FileUploadModule,
        RippleModule,        
        ChipModule,
        TableModule,
        EditorModule,
        EntradaListarRoutingModule,    
        HttpClientModule,        
        TooltipModule,
        DividerModule,
        SplitButtonModule,
        ConfirmDialogModule,
        ProgressSpinnerModule
    ],
    providers: [ConfirmationService],
    declarations: [EntradaListarComponent]
})
export class EntradaListarModule { }
